import { Directive, inject, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
  selector: '[idpWidgetHeight]',
  standalone: true
})
export class WidgetHeightDirective implements OnDestroy {
  private renderer = inject(Renderer2);
  private element: Element | null = null;
  private readonly minHeightClass = 'min-h-[132px]';
  private readonly laptopMinHeightClass = 'laptop:min-h-[122px]';

  addHeight(): void {
    this.element = document.querySelector('.header__widgets');
    if (this.element) {
      this.renderer.addClass(this.element, this.minHeightClass);
      this.renderer.addClass(this.element, this.laptopMinHeightClass);
    }
  }

  removeHeight(): void {
    if (this.element) {
      this.renderer.removeClass(this.element, this.minHeightClass);
      this.renderer.removeClass(this.element, this.laptopMinHeightClass);
    }
  }

  ngOnDestroy(): void {
    this.removeHeight();
  }
}
